<template>
  <div class="page-main page-btns">
    <page-title />
    <div class="home-msg">
      <page-card :noHead="true" style="margin-bottom:20px;">
        <template slot="tab">
          <el-tabs v-model="active" class="page-tab" @tab-click="handleClick">
            <el-tab-pane name="OIL">
              <span slot="label">
                <svg-icon icon-class="tn-oil" v-if="active === 'OIL'" />
                <svg-icon icon-class="tn-oil1" v-else />
                Oil
              </span>
            </el-tab-pane>
            <el-tab-pane name="GAS">
              <span slot="label">
                <svg-icon icon-class="tn-gas2" v-if="active === 'GAS'" />
                <svg-icon icon-class="tn-gas" v-else />
                Gas
              </span>
            </el-tab-pane>
          </el-tabs>
        </template>
        <template slot="body">
          <el-row>
            <el-col :span="18">
              <p
                style="font-size: 0.14rem; color: rgba(0, 0, 0, 0.65); line-height: 1.5em"
              >
                My Balance
              </p>
              <p
                style="
                  font-size: 0.3rem;
                  color: #000;
                  line-height: 1.5em;
                  font-weight: 600;
                "
              >
                <span v-if="balanceType == 2">-</span
                ><big-number :number="balance" /> Unit
              </p>
            </el-col>
            <el-col :span="6" style="text-align: right">
              <el-button icon="el-icon-s-finance" @click="handleDeposit(1)"
                >Deposit</el-button
              >
              <el-button
                style="background: #1e54e7; color: azure"
                @click="handleWithdraw(2)"
                >Withdraw</el-button
              >
            </el-col>
          </el-row>
          <el-row style="margin: 0.2rem auto" class="page_con">
            <p class="fl">
              Expense:
              <span>{{ expense }} </span>
              Unit
            </p>
            <p class="fl">
              Income:
              <span>{{ income }} </span>
              Unit
            </p>
          </el-row>
        </template>
      </page-card>

      <page-card :noHead="true" class="no-padding">
        <div slot="body" class="page-table">
          <div class="spaceBetween search-box">
            <span class="search-title">Deposit details</span>
            <div class="spaceLeft search-form">
              <search-date-time
                ref="date"
                @valChange="valChange($event, 'dateTo')"
                label="Date"
              />
              <search-select
                ref="type"
                @valChange="valChange($event, 'type')"
                label="Type"
                :options="typeList"
              />
            </div>
          </div>
          <div>
            <el-table :data="tableData" style="width: 100%">
              <el-table-column prop="timestamp" label="Date" align="center">
                <template slot-scope="{ row }">
                  {{ row.timestamp | time("yyyy-MM-DD") }}
                </template>
              </el-table-column>
              <el-table-column prop="type" label="Type" align="center">
                <template slot-scope="{ row }">
                  {{ row.type === 1 ? "Income" : "Expense" }}
                </template>
              </el-table-column>
              <el-table-column label="Event" align="center">
                <template slot-scope="{ row }">
                  {{ typeVal(row.type) }}
                </template>
              </el-table-column>
              <el-table-column prop="amount" label="Amounts（UNIT）" align="center">
              </el-table-column>
            </el-table>
            <pagination
              :total="total"
              :page.sync="queryParams.page"
              :limit.sync="queryParams.pageSize"
              @pagination="getList()"
            />
          </div>
        </div>
      </page-card>
    </div>

    <el-dialog
      :title="type === 1 ? 'Deposit' : 'Withdraw'"
      :visible.sync="open"
      width="5rem"
      :close-on-click-modal="false"
      @close="handleCancel"
    >
      <el-form ref="form" :model="form" label-position="top" @close="handleCancel">
        <el-form-item label="Expense Balance：">
          <p class="des">
            <span v-if="balanceType == 2">-</span>
            <span><big-number :number="balance" /></span> Unit
          </p>
        </el-form-item>
        <el-form-item
          class="formItem"
          :label="type === 1 ? 'Deposit Quantity' : 'Withdraw Quantity'"
          prop="value"
          :rules="{ required: true, message: 'Please enter balance' }"
        >
          <p class="balance" v-if="type === 1">
            Balance:<big-number :number="balanceNum" />
          </p>
          <el-input v-model="form.value" autocomplete="off" placeholder="Please fill in...">
            <template slot="append">Unit</template>
          </el-input>
        </el-form-item>
      </el-form>
      <div slot="footer">
        <el-button @click="handleCancel">No</el-button>
        <el-button type="primary" :loading="btnLoading" @click="handleSubmite"
          >Submit</el-button
        >
      </div>
    </el-dialog>
  </div>
</template>

<script>
import SearchDateTime from "@/components/SearchDate/SearchDateTime.vue";
import { marginList } from "@/api/expenseMansgement";

import { toBigNum } from "@/utils/bigNumberTran.js";
export default {
  components: {
    SearchDateTime,
  },
  data() {
    return {
      active: "OIL",
      searchData: {},
      typeList: [
        {
          name: "Income",
          value: "1",
        },
        {
          name: "Expense",
          value: "2",
        },
      ],
      tableData: [],
      total: 0,
      queryParams: {
        page: 1,
        pageSize: 10,
      },
      type: 1,
      open: false,
      form: {
        value: undefined,
      },
      btnLoading: false,

      oilContract: null,
      oilContractAddress: null,
      gasContract: null,
      gasContractAddress: null,
      balance: 0,
      balanceType: 1,
      income: 0,
      expense: 0,
      balanceNum: 0,
    };
  },
  mounted() {
    Promise.all([this.getoil(), this.getgas()]).then(() => {
      this.queryDepositBalance();
      this.getList();
    });
  },
  methods: {
    async getoil() {
      let res = await this.getAbi("OilData");
      this.oilContract = new web3.eth.Contract(res.data.abi, res.data.address);
      this.oilContractAddress = res.data.address;
    },
    async getgas() {
      let res = await this.getAbi("GasData");
      this.gasContract = new web3.eth.Contract(res.data.abi, res.data.address);
      this.gasContractAddress = res.data.address;
    },
    async queryDepositBalance() {
      try {
        let contract = this.active === "OIL" ? this.oilContract : this.gasContract;
        let res = await contract.methods["marginOf"](
          this.$store.getters.metaMaskObj.account
        ).call({
          from: this.$store.getters.metaMaskObj.account,
        });
        this.balance = res[0];
        this.balanceType = res[1];
      } catch (e) {
        console.log(e);
      }
    },
    async getBalance() {
      const num = await web3.eth.getBalance(this.$store.getters.metaMaskObj.account);
    },
    handleClick() {
      this.queryParams.page = 1;
      this.searchData = {}
      this.$refs.date.clearVal()
      this.$refs.type.clearVal()
      this.queryDepositBalance();
      this.getList();
    },
    getList() {
      let json = {
        account: this.$store.getters.metaMaskObj.account,
        ...this.queryParams,
        dateFrom: this.searchData.dateFrom,
        dateTo: this.searchData.dateTo,
        type:
          this.searchData.type == 1
            ? [1]
            : this.searchData.type == 2
            ? [2, 3, 4]
            : undefined,
        assetType: this.active,
      };
      marginList(json).then((res) => {
        this.tableData = res.data.data;
        this.total = res.data.total;
        this.income = res.data.income;
        this.expense = res.data.expense;
      });
    },
    valChange(data, key) {
      if (Array.isArray(data) && data.length > 0) {
        this.searchData.dateFrom = data[0];
        this.searchData.dateTo = data[1];
      } else {
        this.searchData[key] = this.isObj(data) ? data.value : data;
      }
      this.getList();
    },
    isObj(obj) {
      return Object.prototype.toString.call(obj) === "[object Object]";
    },
    async handleDeposit() {
      this.balanceNum = await web3.eth.getBalance(
        this.$store.getters.metaMaskObj.account
      );
      this.type = 1;
      this.open = true;
    },
    handleWithdraw() {
      this.type = 2;
      this.open = true;
    },
    handleCancel() {
      this.$refs.form.resetFields();
      this.open = false;
    },
    handleSubmite() {
      this.$refs.form.validate((valid) => {
        if (valid) {
          this.btnLoading = true;
          const contract = this.active === "OIL" ? this.oilContract : this.gasContract;
          const address =
            this.active === "OIL" ? this.oilContractAddress : this.gasContractAddress;
          if (this.type === 1) {
            const tx_builder = contract.methods["prepay"]();
            const encoded_tx = tx_builder.encodeABI();
            let json = {
              gas: this.$store.getters.gas,
              from: this.$store.getters.metaMaskObj.account,
              to: address,
              value: toBigNum(this.form.value),
              data: encoded_tx,
            };
            web3.eth
              .sendTransaction(json)
              .then((res) => {
                this.btnLoading = false;
                this.$message.success(`Deposited successfully!`);
                this.queryDepositBalance();
                this.getList();
                this.handleCancel();
              })
              .catch((error) => {
                this.$message.error("operation failed");
                console.error(error);
                this.btnLoading = false;
              });
          } else {
            const tx_builder = contract.methods["withdraw"](toBigNum(this.form.value));
            const encoded_tx = tx_builder.encodeABI();

            let json = {
              gas: this.$store.getters.gas,
              from: this.$store.getters.metaMaskObj.account,
              to: address,
              value: 0,
              data: encoded_tx,
            };
            web3.eth
              .sendTransaction(json)
              .then((res) => {
                this.$message.success(`Withdrawed successfully!`);
                this.btnLoading = false;
                this.queryDepositBalance();
                this.getList();
                this.handleCancel();
              })
              .catch((error) => {
                this.$message.error("operation failed");
                console.error(error);
                this.btnLoading = false;
              });
          }
        }
      });
    },
    typeVal(val) {
      let arr = [
        null,
        "Deposit",
        "Withdraw",
        "Physical mineral Audit",
        "ETH Audit",
        "BTC Audit",
      ];
      return arr[val];
    },
  },
};
</script>
<style scoped lang="scss">
p {
  margin: 0;
}

.page_con {
  p {
    font-size: 0.22rem;
    color: #929dad;
    line-height: 0.36rem;

    span {
      color: rgba(0, 0, 0, 0.85);
    }
  }

  p:first-child {
    background: url("~@/assets/image/expense.png") no-repeat left center;
    background-size: contain;
    padding-left: 0.45rem;
    margin-right: 0.6rem;
  }

  p:last-child {
    background: url("~@/assets/image/income.png") no-repeat left center;
    background-size: contain;
    padding-left: 0.45rem;
  }
}

.des {
  text-align: left;
  font-size: 0.2rem;

  span {
    color: #000;
    font-size: 0.3rem;
  }
}

::v-deep .el-dialog .el-dialog__header {
  border-bottom: 1px solid #dcdfe6;
}

::v-deep .el-dialog .el-dialog__footer {
  border-top: 1px solid #dcdfe6;
}

.search-box {
  padding: 0.24rem 0.32rem;
  border-bottom: 1px solid #f0f0f0;

  .search-title {
    font-size: 0.22rem;
    font-weight: bold;
  }

  .search-item {
    margin-left: 0.24rem;
  }
}

.formItem {
  position: relative;

  .balance {
    position: absolute;
    right: 10px;
    top: -43px;
    color: #aaaaaa;
  }
}
</style>
